import defaultizeValueFormatter from '../internals/defaultizeValueFormatter';
const formatter = ({
  series,
  seriesOrder
}) => {
  return {
    series: defaultizeValueFormatter(series, v => `(${v.x}, ${v.y})`),
    seriesOrder
  };
};
export default formatter;